module.exports = __webpack_public_path__ + "static/media/i-bidder-com_logo.7cf9dc37.png";